<template>
  <div class="firstpage" ref='vantaRef'>
   <div class="content">
      <div class="left">
        <Myself/>
         <el-input
            placeholder="请输入关键字词"
            prefix-icon="el-icon-search"
            style="margin: 30px 0;"
            @change="getArticles()"
            v-model="keywords">
          </el-input>
          <!-- <Ranking style="margin-bottom: 30px;" :list="rankList"/> -->
          <SideContent title="点击排行" :list="rankList"/>
          <!-- <Friendship/> -->
      </div>
      <div class="right">
        <div v-for="(item,index) in articles" style="margin-bottom: 30px;border-radius: 24px;overflow: hidden;cursor: pointer;" :key="index" @click="enterInfo(item.id)">
          <ArticleList :article="item"/>
        </div>
        <el-pagination
          background
          class="pagination"
          style="margin: 20px 0;"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
   </div>
  </div>
</template>
<script>
  import ArticleList from '../../components/ArticleList.vue'
  import Myself from '../../components/Myself.vue'
  import SideContent from '../../components/SideContent.vue'
  import Friendship from './components/friendship.vue'
  import {animateBg} from '../../utils/mixins.js'
  export default{
    components:{
      ArticleList,
      Myself,
      Friendship,
      SideContent
    },
    data(){
      return {
        keywords:'',
        vantaEffect:null,
        currentPage:1,
        articles:[],
        total:0,
        page:1,
        limit:10,
        rankList:[]
      }
    },
    created() {
      this.getArticles()
      this.getClickRank()
    },
    mixins:[animateBg],
    methods:{
      // 进入文章详情页
      enterInfo(id){
        this.$router.push({
          path:'/articleInfo/'+id,
        })
      },
      handleSizeChange(val) {
              this.limit = val
              this.getArticles()

            },
      handleCurrentChange(val) {
              this.page = val
              this.getArticles()
            },
      getArticles(){
        const  timestamp = Date.now()
        this.$api.getArticles({t:'json',timestamp,keywords:this.keywords,page:this.page,limit:this.limit})
          .then(res=>{
            if(res.code == 0){
                this.total = res.count
                this.articles = res.data
            }else{
              console.log(res.msg)
            }
          })
          .catch(err=>{
            console.log(err)
          })
      },
      // 点击排行
      getClickRank(){
        const timestamp = Date.now()
        this.$api.getClickRank({t:'json',timestamp})
        .then(res=>{
          if(res.code == 0){
            this.rankList = res.data
          }else{
            console.log(res.msg)
          }
        })
        .catch(err=>{
          console.log(err)
        })
      },
    }
  }
</script>

<style lang="scss">
  .firstpage{
    background-color: transparent;
    margin-top: 20px;
    height: calc(100vh - 120px);
    // min-height: calc(100vh - 129px - 20px);
    // min-height: 100vh;
    .content{
     display: flex;
     justify-content: space-between;
     background-color: rgba(999, 999, 999, .6);
     width: 60%;
     z-index: 1;
     margin: 0 auto;
     .left{
        width: 28%;
        margin-left: 20px;
     }
     .right{
       position: relative;
       width: 66%;
       margin-right: 20px;
       height:calc(100vh - 122px);
       // height:calc(100vh - 129px - 20px);
       overflow-y: scroll;
       overflow-x: hidden;
       .pagination{
         position: relative;
         bottom: 10px;
         left: 0;
       }
     }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/firstPage/firstPage.vue